import { type PropsWithChildren } from "react";
import { useSelector } from "react-redux";

import { ScrollArea } from "@base-ui/react";
import { Container, useMediaQuery, useTheme } from "@mui/material";

export default function FilterBar({ children, allowExpand }: PropsWithChildren<{ allowExpand?: boolean }>) {
  const logSettings = useSelector((state) => state.settings.logs);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container
      maxWidth={matches || (logSettings.expand && allowExpand) ? "auto" : "xl"}
      className={matches ? "px-0!" : undefined}
      sx={{
        position: "sticky",
        top: matches ? 0 : 8,
        left: 0,
        right: 0,
        zIndex: 30,
      }}
    >
      <ScrollArea.Root>
        <ScrollArea.Viewport
          className={`mb-2 w-full rounded-lg bg-white/85 shadow-[0.1px_0.3px_0.55px_rgba(0,0,0,0.053),0.2px_0.9px_2px_rgba(0,0,0,0.077),1px_4px_10px_rgba(0,0,0,0.13)] backdrop-blur-md backdrop-saturate-200 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-[#0068d8] dark:bg-[#323236]/85 ${matches ? "rounded-none" : ""}`}
        >
          <ScrollArea.Content className="flex flex-nowrap gap-0.5 p-2">{children}</ScrollArea.Content>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          className="pointer-events-none relative mx-2 my-1 flex h-1 rounded-sm bg-zinc-200 opacity-0 transition-opacity before:absolute before:right-0 before:-bottom-2 before:left-0 before:h-5 before:w-full before:content-[''] data-hovering:pointer-events-auto data-hovering:opacity-100 data-hovering:delay-0 data-scrolling:pointer-events-auto data-scrolling:opacity-100 data-scrolling:duration-0 dark:bg-zinc-500"
          orientation="horizontal"
        >
          <ScrollArea.Thumb className="w-full rounded-sm bg-zinc-500 dark:bg-zinc-200" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </Container>
  );
}
